import { Component, Input, OnChanges } from '@angular/core';
import { DocumentInfo, DocumentPermission, IconType, IoniconsOutline } from '@pt/pt-models';
import { AvailableOperations } from 'it/primatoo/openapi/api/org/schemas/common/AvailableOperations';
import { DocResourceStatus } from 'it/primatoo/openapi/api/org/schemas/common/DocResourceStatus';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EditorDocumentsDialogService } from '../../services/editor-documents-dialog.service';
import { DocumentPermissionService } from '@pt/pt-core';

@UntilDestroy()
@Component({
  selector: 'pt-template-header-action',
  template: `

    <div class="d-flex flex-row">
      <button
        *ngIf="docInfo?.status === DocResourceStatus.DRAFT"
        [disabled]="loading"
        class='btn btn-sm btn-success d-flex font-14 position-relative ms-1 h-24  d-flex align-items-center'
        (click)='publish()'>
        <pt-icon [key]="IconGlobe"></pt-icon>
        <span class='ms-1'>{{ "BUTTON.PUBLISH" | translate }}</span>
      </button>

      <button
        *ngIf="docInfo?.status === DocResourceStatus.PUBLISHED"
        [disabled]="loading"

        class='btn btn-sm btn-success d-flex font-14 position-relative ms-1 h-24 d-flex align-items-center'
        (click)='reopen()'>
        <pt-icon [key]="IconEdit"></pt-icon>
        <span class='ms-1'>{{ "BUTTON.REOPEN_PROCESS" | translate }}</span>
      </button>
    </div>
  `,
  styles: [`
    .h-24 {
      height: 24px;
    }
  `]
})
export class TemplateHeaderActionsComponent implements OnChanges {
  @Input() availableOperations: AvailableOperations;
  @Input() docInfo: DocumentInfo;
  @Input() loading: boolean;

  DocResourceStatus = DocResourceStatus;
  IconLike = IoniconsOutline.like;

  public disabledPublishDocument = true;
  public disabledReopenDocument = true;
  public disabledValidateDocument = true;

  public showBtnPublishDocument = true;
  public showBtnReopenDocument = true;
  public showBtnValidateDocument = true;

  IconEdit = IoniconsOutline.edit;
  IconGlobe = IoniconsOutline.globe;
  constructor(private documentPermissionService: DocumentPermissionService,
              private documentsDialogService: EditorDocumentsDialogService) {
  }

  ngOnChanges(): void {
    if (this.docInfo && this.docInfo.docType && this.availableOperations) {
      this.alignValue();
    }
  }

  alignValue() {

    this.disabledPublishDocument = true;
    this.disabledReopenDocument = true;
    this.disabledValidateDocument = true;

    this.showBtnPublishDocument = true;
    this.showBtnReopenDocument = true;
    this.showBtnValidateDocument = true;

    const permission: DocumentPermission = this.documentPermissionService.toDocPermission(this.docInfo.docType, this.availableOperations);
    this.showBtnPublishDocument = permission.publishBtnVisible;
    this.showBtnReopenDocument = permission.reopenBtnVisible;
    this.showBtnValidateDocument = permission.validateBtnVisible;

    this.disabledPublishDocument = !permission.publishBtnEnabled;
    this.disabledReopenDocument = !permission.reopenBtnEnabled;
    this.disabledValidateDocument = !permission.validateBtnEnabled;
  }

  validate() {
    this.documentsDialogService.runValidateDocumentDialog(this.docInfo.docType, this.docInfo.docId, this.docInfo.status)
      .pipe(untilDestroyed(this))
      .subscribe((success) => {
        if (success) {
          window.location.reload();
        }
      });
  }

  publish() {
    this.documentsDialogService.runPublishDocumentDialog(this.docInfo.docType, this.docInfo.docId, this.docInfo.status)
      .pipe(untilDestroyed(this))
      .subscribe((success) => {
        if (success) {
          window.location.reload();
        }
      });
  }

  reopen() {
    this.documentsDialogService.runReopenDocumentDialog(this.docInfo.docType, this.docInfo.docId, this.docInfo.status)
      .pipe(untilDestroyed(this))
      .subscribe((success) => {
        if (success) {
          window.location.reload();
        }
      });
  }

  confirmAction(actionType: 'PUBLISH' | 'REOPEN') {
    // const title = 'TITLE.TREATMENT_REOPEN';
    // const message = 'MESSAGE.TREATMENT_REOPEN';
    //
    // this.widgetDialogService.runConfirmDialog(title, message).pipe(
    //   map((response) => {
    //     if (response) {
    //       this.store.dispatch(TreatmentActions.reopenTreatment({
    //         id: action?.id
    //       }));
    //     }
    //   })
    // );
  }

  protected readonly IconType = IconType;
}
